'use strict';

angular.module('bootstrap').factory('SuporteIeItp', SuporteIeItp);

SuporteIeItp.$inject = [];

function SuporteIeItp() {
    return {
        // Todos os browsers por padrão desabilitam o cache
        // em requisições AJAX, exceto o IE, então vamos desabilitar
        // para evitar incoveniência nas requisições, isso não
        // afetarar o funcionamento dos demais browsers.
        request: function (config) {

            config.headers = config.headers || {};

            //config.headers['cache-control'] = 'no-cache';

            return config;
        }
    }
}


// WEBPACK FOOTER //
// ./src/core/config/central-interceptors.js